import React, { useState } from 'react';
import { Header } from './components/Header.tsx';
import { Hero } from './components/Hero.tsx';
import { Services } from './components/Services.tsx';
import { Suppliers } from './components/Suppliers.tsx';
import { Testimonials } from './components/Testimonials.tsx';
import { Footer } from './components/Footer.tsx';
// import { EmergencyModal } from './components/EmergencyModal.tsx';
import { WhatsAppCall } from './components/WhatsAppCall.tsx';
import { AuthModal } from './components/AuthModal.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import openWhatsApp from './utils/whatsapp';

function App() {
  const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'register'>('login');
  const [setUserName] = useState<string | null>(null); // userName, 

  const phone = process.env.REACT_APP_WHATSAPP_NUMBER;

  const handleEmergencyClick = () => {
    //setIsEmergencyModalOpen(true);
    const message = process.env.REACT_APP_MESSAGE_EMERGENCY;
    openWhatsApp(phone, message);
  };

  const handleLoginClick = () => {
    setAuthMode('login');
    setIsAuthModalOpen(true);
  };

  // Ahora abre WhatsApp en lugar de abrir el modal de registro
  /*const handleRegisterClick = () => {
    setAuthMode('register');
    setIsAuthModalOpen(true);
  };*/
  const handleRegisterClick = () => {
    const message = process.env.REACT_APP_MESSAGE_REGISTER;
    openWhatsApp(phone, message);
  };

  // Modifico para que maneje también la llamada a Whatsapp....
  const handleServiceRequest = () => {
    // Check if user is logged in
    // For demo purposes, we'll open the emergency modal
    setIsEmergencyModalOpen(true);
  };

  const handleServiceSelect = (serviceId: number) => {
    // Handle service selection
    console.log('Service selected:', serviceId);
    handleServiceRequest();
  };

  return (
    <AuthProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
        <Header
          onEmergencyClick={handleEmergencyClick}
          onLoginClick={handleLoginClick}
          onRegisterClick={handleRegisterClick}
        />
        
        <main>
          <Hero onServiceRequest={handleServiceRequest} />
          <Services onServiceSelect={handleServiceSelect} />
          <Suppliers onServiceSelect={handleServiceSelect} />
          <Testimonials />
        </main>

        <Footer />

        {/* Modals */}
        <WhatsAppCall //EmergencyModal
          isOpen={isEmergencyModalOpen}
          onClose={() => setIsEmergencyModalOpen(false)}
        />
        
        <AuthModal
          isOpen={isAuthModalOpen}
          onClose={() => setIsAuthModalOpen(false)}
          mode={authMode}
          onLoginSuccess={(name: string) => {
            setUserName(name);
            setIsAuthModalOpen(false);
          }}
        />
      </div>
    </AuthProvider>
  );
}

export default App;
